/**
 * 新闻资讯管理后台api
 * 新闻资讯管理后台相关接口
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The NewsAdminDetailVo model module.
   * @module news/model/NewsAdminDetailVo
   * @version 0.1.0
   */

  /**
   * Constructs a new <code>NewsAdminDetailVo</code>.
   * @alias module:news/model/NewsAdminDetailVo
   * @class
   */
  var exports = function() {
    var _this = this;













  };

  /**
   * Constructs a <code>NewsAdminDetailVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:news/model/NewsAdminDetailVo} obj Optional instance to populate.
   * @return {module:news/model/NewsAdminDetailVo} The populated <code>NewsAdminDetailVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'content')) {
        obj['content'] = ApiClient.convertToType(data['content'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'categoryId')) {
        obj['categoryId'] = ApiClient.convertToType(data['categoryId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'coverUri')) {
        obj['coverUri'] = ApiClient.convertToType(data['coverUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'coverUrl')) {
        obj['coverUrl'] = ApiClient.convertToType(data['coverUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'author')) {
        obj['author'] = ApiClient.convertToType(data['author'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'publishTime')) {
        obj['publishTime'] = ApiClient.convertToType(data['publishTime'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtCreate')) {
        obj['gmtCreate'] = ApiClient.convertToType(data['gmtCreate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtModified')) {
        obj['gmtModified'] = ApiClient.convertToType(data['gmtModified'], 'Date');
      }
    }
    return obj;
  }

  /**
   * 新闻ID
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 状态：0-草稿 1-已发布 2-已删除
   * @member {Integer} status
   */
  exports.prototype['status'] = undefined;
  /**
   * 新闻标题
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 新闻摘要，不传则自动从内容截取
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 新闻内容（富文本）
   * @member {String} content
   */
  exports.prototype['content'] = undefined;
  /**
   * 新闻分类：1-通知，2-动态，3-政策
   * @member {Integer} categoryId
   */
  exports.prototype['categoryId'] = undefined;
  /**
   * 封面URI
   * @member {String} coverUri
   */
  exports.prototype['coverUri'] = undefined;
  /**
   * 封面URL
   * @member {String} coverUrl
   */
  exports.prototype['coverUrl'] = undefined;
  /**
   * 作者
   * @member {String} author
   */
  exports.prototype['author'] = undefined;
  /**
   * 发布时间
   * @member {Date} publishTime
   */
  exports.prototype['publishTime'] = undefined;
  /**
   * 创建时间
   * @member {Date} gmtCreate
   */
  exports.prototype['gmtCreate'] = undefined;
  /**
   * 修改时间
   * @member {Date} gmtModified
   */
  exports.prototype['gmtModified'] = undefined;



  export default exports;
;


